import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_MeasurementUnit } from '@app/hcs-shared';
export const dispatch_onMeasurementUnitChanged = new ThunderDispatcherV3('__onMeasurementUnitUpdated');
export class ModuleFE_MeasurementUnit_Class extends ModuleFE_BaseApi {
    measurementToDimensionDictionary = {};
    constructor() {
        super(DBDef_MeasurementUnit, dispatch_onMeasurementUnitChanged);
        this.initializeMeasurementUnitsMap();
    }
    initializeMeasurementUnitsMap = () => {
        this.measurementToDimensionDictionary['g'] = 'mass';
        this.measurementToDimensionDictionary['mg'] = 'mass';
        this.measurementToDimensionDictionary['mcg'] = 'mass';
        this.measurementToDimensionDictionary['ng'] = 'mass';
        this.measurementToDimensionDictionary['pg'] = 'mass';
        this.measurementToDimensionDictionary['µg'] = 'mass';
        this.measurementToDimensionDictionary['l'] = 'volume';
        this.measurementToDimensionDictionary['dl'] = 'volume';
        this.measurementToDimensionDictionary['ml'] = 'volume';
        this.measurementToDimensionDictionary['fl'] = 'volume';
        this.measurementToDimensionDictionary['s'] = 'time';
        this.measurementToDimensionDictionary['min'] = 'time';
        this.measurementToDimensionDictionary['h'] = 'time';
        this.measurementToDimensionDictionary['24h'] = 'time';
        this.measurementToDimensionDictionary['mmol'] = 'moles';
        this.measurementToDimensionDictionary['µmol'] = 'moles';
        this.measurementToDimensionDictionary['nmol'] = 'moles';
        this.measurementToDimensionDictionary['mEq'] = 'moles';
        this.measurementToDimensionDictionary['µ'] = 'enzymatic activity';
        // this.measurementToDimensionDictionary[''] = '';
    };
    getDimensionForUnit = (unit) => {
        return this.measurementToDimensionDictionary[unit.toLowerCase()];
    };
}
export const ModuleFE_MeasurementUnit = new ModuleFE_MeasurementUnit_Class();
//# sourceMappingURL=ModuleFE_MeasurementUnit.js.map